import {Route, Routes} from '@angular/router';

import { HomeComponent } from './';
import { layoutRoutes } from '../layouts';
import { UserRouteAccessService } from '../shared/auth/user-route-access-service';
import { ContactDetailComponent } from '../base-data/components/contact-detail/contact-detail.component';
import { MarketsComponent } from '../markets/components/markets/markets.component';
import { MarketDetailComponent } from '../markets/components/market-detail/market-detail.component';
import { BaseDataComponent } from '../base-data/components/base-data/base-data.component';
import { CompanyDetailComponent } from '../base-data/components/company-detail/company-detail.component';
import { SalesunitDetailComponent } from '../base-data/components/salesunit-detail/salesunit-detail.component';
import { EmployeeComponent, EmployeeDetailComponent } from '../employee';
import { EvaluationComponent } from '../evaluation';
import { AdministrationComponent } from '../administration';
import { LogsComponent } from '../logs';
import { ExpenseComponent } from '../expense';
import { StatisticsByWeekComponent } from '../evaluation/components/statistics-by-week/statistics-by-week.component';
import { StatisticsDatamanagementComponent } from '../evaluation/components/statistics-datamanagement/statistics-datamanagement.component';
import { MessagesComponent } from '../messages';
import { OpenPaymentInfoComponent } from '../evaluation/components/open-payment-info/open-payment-info.component';
import { GeographicalDataComponent } from '../evaluation/components/geographical-data/geographical-data.component';
import {GrantedDiscountsComponent} from '../evaluation/components/granted-discounts/granted-discounts.component';
import { DocumentsComponent } from '../documents/documents/documents.component';
import {CurrentLossComponent} from '../evaluation/components/current-loss/current-loss.component';
import {EnergyConsumptionComponent} from '../evaluation/components/power-consumption-markets/energy-consumption.component';
import {NewsListComponent} from '../news/news-list/news-list.component';
import {MarketwebsiteListComponent} from '../administration/components/marketwebsite-list/marketwebsite-list.component';
import {MarketwebsiteMerchantsComponent} from '../administration/components/marketwebsite-merchants/marketwebsite-merchants.component';
import {MarketwebsitesSmsComponent} from '../messages/components/marketwebsites-sms/marketwebsites-sms.component';
import {MarketwebsiteMerchantsHelpComponent} from '../administration/components/marketwebsite-merchants-help/marketwebsite-merchants-help.component';

const HOME_ROUTES: Route[] = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [UserRouteAccessService],
    data: {
      authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
      pageTitle: 'home.title'
    }
  },
  {
    path: 'base-data',
    canActivate: [UserRouteAccessService],
    data: {
      authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
      pageTitle: 'base-data.title'
    },
    children: [
      {
        path: '',
        component: BaseDataComponent
      },
      {
        path: 'company',
        canActivate: [UserRouteAccessService],
        data: {
          authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
          pageTitle: 'base-data.title'
        },
        children: [
          {
            path: ':id',
            children: [
              {
                path: '',
                component: CompanyDetailComponent
              },
              {
                path: 'contact',
                canActivate: [UserRouteAccessService],
                data: {
                  authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
                  pageTitle: 'base-data.title'
                },
                children: [
                  {
                    path: ':id',
                    component: ContactDetailComponent
                  }
                ]
              },
              {
                path: 'salesunit',
                canActivate: [UserRouteAccessService],
                data: {
                  authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
                  pageTitle: 'base-data.title'
                },
                children: [
                  {
                    path: ':id',
                    component: SalesunitDetailComponent
                  }
                ]
              }
            ]
          },
        ]
      }
    ]
  },
  {
    path: 'base-data-archive',
    canActivate: [UserRouteAccessService],
    data: {
      authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
      pageTitle: 'base-data.archive-title'
    },
    children: [
      {
        path: '',
        component: BaseDataComponent
      },
      {
        path: 'company',
        canActivate: [UserRouteAccessService],
        data: {
          authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
          pageTitle: 'base-data.title'
        },
        children: [
          {
            path: ':id',
            children: [
              {
                path: '',
                component: CompanyDetailComponent
              },
              {
                path: 'contact',
                canActivate: [UserRouteAccessService],
                data: {
                  authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
                  pageTitle: 'base-data.title'
                },
                children: [
                  {
                    path: ':id',
                    component: ContactDetailComponent
                  }
                ]
              },
              {
                path: 'salesunit',
                canActivate: [UserRouteAccessService],
                data: {
                  authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
                  pageTitle: 'base-data.title'
                },
                children: [
                  {
                    path: ':id',
                    component: SalesunitDetailComponent
                  }
                ]
              }
            ]
          },
        ]
      }
    ]
  },
  {
    path: 'open-accountings',
    canActivate: [UserRouteAccessService],
    data: {
      authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
      pageTitle: 'markets.title'
    },
    children: [
      {
        path: '',
        component: MarketsComponent
      },
      {
        path: ':id',
        canActivate: [UserRouteAccessService],
        data: {
          authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
          pageTitle: 'market.title'
        },
        component: MarketDetailComponent
      }
    ]
  },
  {
    path: 'planning',
    canActivate: [UserRouteAccessService],
    data: {
      authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
      pageTitle: 'markets.planning-title'
    },
    children: [
      {
        path: '',
        component: MarketsComponent
      },
      {
        path: ':id',
        canActivate: [UserRouteAccessService],
        data: {
          authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
          pageTitle: 'market.title'
        },
        component: MarketDetailComponent
      }
    ]
  },
  {
    path: 'archive',
    canActivate: [UserRouteAccessService],
    data: {
      authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
      pageTitle: 'markets.archive-title'
    },
    children: [
      {
        path: '',
        component: MarketsComponent
      },
      {
        path: ':id',
        canActivate: [UserRouteAccessService],
        data: {
          authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
          pageTitle: 'market.title'
        },
        component: MarketDetailComponent
      }
    ]
  },
  {
    path: 'employee',
    canActivate: [UserRouteAccessService],
    data: {
      authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
      pageTitle: 'employee.title'
    },
    children: [
      {
        path: '',
        component: EmployeeComponent
      },
      {
        path: ':id',
        canActivate: [UserRouteAccessService],
        data: {
          authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
          pageTitle: 'employee.title'
        },
        component: EmployeeDetailComponent
      }
    ]
  },
  {
    path: 'messages',
    canActivate: [UserRouteAccessService],
    data: {
      authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
      pageTitle: 'messages.title'
    },
    children: [
      {
        path: '',
        component: MessagesComponent
      }
    ]
  },
  {
    path: 'evaluation',
    canActivate: [UserRouteAccessService],
    data: {
      authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
      pageTitle: 'evaluation.title'
    },
    children: [
      {
        path: '',
        component: EvaluationComponent
      },
      {
        path: 'statistics-by-week',
        canActivate: [UserRouteAccessService],
        data: {
          authorities: ['ROLE_ADMIN'],
          pageTitle: 'evaluation.title'
        },
        component: StatisticsByWeekComponent
      },
      {
        path: 'statistics-datamanagement',
        canActivate: [UserRouteAccessService],
        data: {
          authorities: ['ROLE_ADMIN'],
          pageTitle: 'evaluation.title'
        },
        component: StatisticsDatamanagementComponent
      },
      {
        path: 'open-payment-info',
        canActivate: [UserRouteAccessService],
        data: {
          authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
          pageTitle: 'evaluation.title'
        },
        component: OpenPaymentInfoComponent
      },
      {
        path: 'geographical-data',
        canActivate: [UserRouteAccessService],
        data: {
          authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER', 'ROLE_GENERAL_MANAGEMENT'],
          pageTitle: 'evaluation.title'
        },
        component: GeographicalDataComponent
      },
      {
        path: 'granted-discounts',
        canActivate: [UserRouteAccessService],
        data: {
          authorities: ['ROLE_ADMIN'],
          pageTitle: 'evaluation.title'
        },
        component: GrantedDiscountsComponent
      },
      {
        path: 'current-loss',
        canActivate: [UserRouteAccessService],
        data: {
          authorities: ['ROLE_ADMIN'],
          pageTitle: 'evaluation.title'
        },
        component: CurrentLossComponent
      },
      {
        path: 'energy-consumption',
        canActivate: [UserRouteAccessService],
        data: {
          authorities: ['ROLE_ADMIN'],
          pageTitle: 'evaluation.title'
        },
        component: EnergyConsumptionComponent
      }
    ]
  },
  {
    path: 'logs',
    canActivate: [UserRouteAccessService],
    data: {
      authorities: ['ROLE_ADMIN'],
      pageTitle: 'logs.title'
    },
    children: [
      {
        path: '',
        component: LogsComponent
      }
    ]
  },
  {
    path: 'administration',
    canActivate: [UserRouteAccessService],
    data: {
      authorities: ['ROLE_SUPERADMIN'],
      pageTitle: 'administration.title'
    },
    children: [
      {
        path: '',
        component: AdministrationComponent
      }
    ]
  },
  {
    path: 'marketwebsites',
    canActivate: [UserRouteAccessService],
    data: {
      authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
      pageTitle: 'administration.marketwebsites-title'
    },
    children: [
      {
        path: '',
        component: MarketwebsiteListComponent
      }
    ]
  },
  {
    path: 'marketwebsites-merchants',
    canActivate: [UserRouteAccessService],
    data: {
      authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
      pageTitle: 'administration.marketwebsites-merchant-title'
    },
    children: [
      {
        path: '',
        component: MarketwebsiteMerchantsComponent
      }
    ]
  },
  {
    path: 'marketwebsites-sms',
    canActivate: [UserRouteAccessService],
    data: {
      authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
      pageTitle: 'administration.sms-title'
    },
    children: [
      {
        path: '',
        component: MarketwebsitesSmsComponent
      }
    ]
  },
  {
    path: 'marketwebsites-merchants-help',
    canActivate: [UserRouteAccessService],
    data: {
      authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
      pageTitle: 'administration.merchanthelp-title'
    },
    children: [
      {
        path: '',
        component: MarketwebsiteMerchantsHelpComponent
      }
    ]
  },
  {
    path: 'documents',
    canActivate: [UserRouteAccessService],
    data: {
      authorities: ['ROLE_ADMIN'],
      pageTitle: 'documents.title'
    },
    children: [
      {
        path: '',
        component: DocumentsComponent
      }
    ]
  },
  {
    path: 'expense',
    canActivate: [UserRouteAccessService],
    data: {
      authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
      pageTitle: 'expense.title'
    },
    children: [
      {
        path: ':id',
        canActivate: [UserRouteAccessService],
        data: {
          authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
          pageTitle: 'expense.title'
        },
        component: ExpenseComponent
      }
    ]
  },
  {
    path: 'news',
    canActivate: [UserRouteAccessService],
    data: {
      authorities: ['ROLE_ADMIN', 'ROLE_BRANCH_MASTER'],
      pageTitle: 'news.title'
    },
    children: [
      {
        path: '',
        component: NewsListComponent
      }
    ]
  },
  ...layoutRoutes
];

export const homeState: Route = {
  path: '',
  children: HOME_ROUTES
};




// WEBPACK FOOTER //
// ./src/app/home/home.route.ts